import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { useToaster } from '@components/toaster';

import { api } from 'api';
import { Loading } from 'components/Loading';
import { useStore } from 'models/Provider';

import { getErrorMessage } from './utils';

export const HireflixSettingsPage = observer(() => {
  const [apiKey, setApiKey] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { t } = useStore();
  const { showError, showSuccess } = useToaster();

  const settingsQuery = useQuery({
    queryKey: ['hireflixSettings'],
    queryFn: api.integrations.hireflixGetSettings,
  });
  function saveSettings() {
    setSubmitting(true);
    api.integrations
      .hireflixSaveSettings(apiKey)
      .then(() => {
        showSuccess(t('integrations.hireflix.settings.save.success'));
      })
      .catch((e) => {
        showError(getErrorMessage(e.response.data.error, t));
      })
      .finally(() => {
        setSubmitting(false);
      });
  }
  return (
    <Stack space={2}>
      <Text font="heading2" text="Hireflix" />
      {settingsQuery.isLoading && <Loading fixed />}
      {settingsQuery.isSuccess && (
        <Stack space={6}>
          <Text text={t('integrations.hireflix.settings.description')} />
          <Separator />
          <TextField
            label={t('integrations.hireflix.settings.apikey.label')}
            isDisabled={submitting}
            onChange={setApiKey}
            placeholder={settingsQuery.data.hasApiKey ? '**********' : undefined}
          />
          <Stack space={0} orientation="horizontal" justify="flex-end">
            <Button
              text={t('integrations.hireflix.settings.submit.label')}
              isDisabled={apiKey === '' || submitting}
              onClick={saveSettings}
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
});
